import { ObjectSchema } from "yup"

interface ISchemaUpdates {
  [key: string]: any
}

export function makeNullableDates(schema?: ObjectSchema<any>) {
  if (!schema) return

  const fields: Record<string, any> = schema.fields || {}
  const updates: ISchemaUpdates = {}

  for (const [key, fieldSchema] of Object.entries(fields)) {
    if (fieldSchema.type !== "date") continue
    updates[key] = fieldSchema.nullable()
  }

  return schema.shape(updates)
}
